import { queryToString } from 'helpers/AppHelpers';
import api from '../api';

export const getFilterCriteriaApi = () =>
  api.get('/PicklistLooseItems/FilterCriteria').then((res) => res.data);

export const getLooseItemsApi = (q) =>
  api.get(`/LooseItems/Shorted?${queryToString(q)}`).then((res) => res.data);
